import React from "react";
import ReactDOM from "react-dom/client";
import { TreezThemeProvider } from "@treez-inc/component-library";
import TreezAuth from "./App";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <TreezThemeProvider>
      <TreezAuth />
    </TreezThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
